export class NewsFilter {
    constructor(){
        if(this.isFilter()){
            if (document.body.offsetWidth < 1324){
                this.scrollTo('#blog');
            }
        }

        if (this.isBlog() || this.isArchive()){
            this.defaultActiveClass();

            if(!this.isPaged()){
                const terms = document.querySelectorAll('.terms  .terms__link:not(.terms__link--all)');
                terms.forEach((term)=>{
                    term.addEventListener('click', (e) =>{
                        e.preventDefault();
                        let slug = term.dataset.slug;
                        let category = '&category='+slug;
                        let query = this.buildQuery(category);

                        this.executeQuery(query);
                    });
                });
            }
        }

        let categoryDropdown = $('#categoryDropdown');
        if (categoryDropdown.length){
            categoryDropdown.select2({
            }).on('select2:select', (e) => {
                let slug = e.params.data.element.dataset.slug;
                let href = e.params.data.element.dataset.href;
                let category = '&category=' + slug;
                let query = this.buildQuery(category);

                if (this.isBlog() || this.isArchive()) {
                    if (slug) {
                        this.executeQuery(query);
                    } else {
                        this.executeQuery(href);
                    }
                }

                this.executeQuery(href);
            });
        }


        let archiveDropdown = $('#archiveDropdown');
        if (archiveDropdown.length){
            archiveDropdown.select2({
            }).on('select2:select', (e) => {
                e.preventDefault();
                let data = e.params.data;
                let year  = '&y='+data.element.dataset.year;
                let month = '&month='+data.element.dataset.month;
                let href = e.params.data.element.dataset.href;

                let url = new URL(this.currentHref());
                let category = url.searchParams.get('category');

                if(this.isBlog() || this.isArchive()){
                    if (category){
                        let query = this.buildQuery(`&category=${category}`+year+month);
                        this.executeQuery(query);
                    }else if (month) {
                        let query = this.buildQuery(year+month);
                        this.executeQuery(query);
                    }else {
                        let query = data.element.dataset.href;
                        this.executeQuery(query);
                    }
                }else {
                    this.executeQuery(href)
                }
            });
        }

    }
    executeQuery(query) {
        window.location.href = query;
    }
    buildQuery(query) {
        return this.currentHref().split('?')[0] +'?' + query;
    }
    currentHref() {
        return window.location.href;
    }
    isFilter(){
        return this.hrefIncludes('?');
    }
    scrollTo(element){
        $([document.documentElement, document.body]).animate({
            scrollTop: $(element).offset().top - 50,
        },0);
    }
    isBlog(){
        return document.body.classList.contains('blog');
    }
    isArchive(){
        return document.body.classList.contains('archive');
    }
    defaultActiveClass(){
        let url = new URL(this.currentHref());
        let category = url.searchParams.get('category');

        if (category && category !== 'undefined'){
            document.querySelector(`[data-slug="${category}"]`).parentElement.classList.add('terms__field--active');
        }else {
            document.querySelector('.terms__field--all').classList.add('terms__field--active');
        }
    }
    isPaged(){
        return this.hrefIncludes('page');
    }
    hrefIncludes($string){
        return this.currentHref().includes($string);
    }
}